import { AuthService } from './../../shared/services/auth.service';
import { Subscription } from 'rxjs';
import {Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SmsService } from './../../shared/services/sms.service';

import {UserCounter} from '../../models/UserCounter';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-messages-report',
  templateUrl: './messages-report.component.html',
  styleUrls: ['./messages-report.component.scss'],
})
export class MessagesReportComponent implements OnInit, OnDestroy {

  month: number = moment().month();
  year: number = moment().year();
  error = null;
  searchClicked = false;

  /** Flag própria da consulta (CU-86akkqppg) — a tela saiu do overlay global. */
  loadingReport = false;
  minDate = moment().subtract(90, 'days');
  maxDate = moment();

  get totalSent(): number {
    return this.result.reduce((prev, next) => prev + next.quantity, 0);
  }

  result: UserCounter[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private smsService: SmsService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        this.month = +params.month;
        this.year = +params.year;

        this.searchClicked = !!(this.month && this.year);

        this.listDailySent();
      }),

      this.authService.userChanged.subscribe(() => this.listDailySent())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  listDailySent(): void {
    if (this.searchClicked) {
      this.loadingReport = true;

      this.subscriptions.push(
        this.smsService.listMessagesByMonthAndyear(this.month, this.year).subscribe({
          next: result => {
            this.result = result.map(item => ({...item, is_old: moment(item.counter_date).isBefore(this.minDate)}));
            this.loadingReport = false;
          },
          error: () => {
            this.result = [];
            this.loadingReport = false;
          },
        })
      );

      return;
    }

    this.result = [];
    this.loadingReport = false;
  }

  search(): void {
    const date = new Date();
    this.error = null;
    // Gambiarra para janeiro, pois é 0 no Moment
    if ((!this.month && this.month !== 0) || !this.year) {
      this.error = 'Mês e Ano são obrigatórios';
      return;
    } else if (+this.year > date.getFullYear()) {
      this.error = 'O ano deve ser menor que o atual';
      return;
    } else if (+this.year === date.getFullYear() && +this.month > date.getMonth() + 1) {
      this.error = 'O mês não pode ser posterior ao atual';
      return;
    }

    const queryParams = {
      month: this.month + 1,
      year: this.year
    };

    this.router.navigate(['/messages-report'], { queryParams });
  }

  reset(): void {
    this.error = null;
  }

  onMonthAndYear(monthAndYear: Moment): void {
    this.month = monthAndYear.month();
    this.year = monthAndYear.year();
    this.search();
  }
}
